
import React from 'react'

const Setting = () => {
  return (
    <div className='container py-10'>
        <h1 className='heading-one !text-secondary-n-400'>Settings</h1>
    </div>
  )
}

export default Setting